import React from "react";
import styled from "styled-components";
import Color from "color";
import { Typography, useTheme, Icon } from "@material-ui/core";
import MonitorWA from "../../assets/MonitorWA";
import CopyrightIcon from "@material-ui/icons/Copyright";

const Footer = () => {
  const { palette } = useTheme();
  const lightGrey = Color(palette.text.primary).fade(0.25).string();
  const grey = Color(palette.text.primary).fade(0.5).string();
  return (
    <Container>
      <Text style={{ fontSize: "20px", marginRight: "10px", color: "#cccccc" }}>
        ©
      </Text>
      <Text colour={grey}> COPYRIGHT 2024</Text>
      <MonitorWA accent={lightGrey} text={grey} />
    </Container>
  );
};

const Container = styled.footer`
  display: flex;
  width: 100%;
  padding: 2rem 6rem;
  align-items: center;
  justify-content: flex-end;
  margin-top: auto;
  .logo-link {
    height: 20px;
  }
  .monitor-logo {
    height: 100%;
  }
`;

const Text = styled(Typography)`
  color: ${(props) => props.colour};
  font-size: 1.2rem;
  line-height: 1;
  margin-right: 1rem;
`;

export default Footer;
